import { useState } from "react";
import {
  MGButton,
  SearchInput,
  MGDatePicker,
  SelectDropdown,
} from "../../../components";

// Third party
import { Menu, MenuItem } from "@mui/material";
import { FiDownload } from "react-icons/fi";
import { addDays } from "../../../utils/date.utils";

const REVIEW_STATUS_OPTIONS = [
  { label: "Approved", value: "APPROVED" },
  { label: "Pending", value: "PENDING" },
  { label: "Rejected", value: "REJECTED" },
];

export const HotelPastToolbar = ({
  searchParams,
  handleSearchParam,
  startDate,
  endDate,
  handleStartDate,
  handleEndDate,
  onApplyDates,
  applyDisabled,
  dateError,
  reviewStatusFilter,
  handleReviewStatusFilter,
  onExport,
  isExporting,
}: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // The page exports the FULL date range (fetching any rows not loaded yet),
  // so this only forwards the chosen format.
  const handleExport = (extension: "csv" | "xlsx") => {
    onExport?.(extension);
    setAnchorEl(null);
  };

  // Future dates are never valid for past scans, so keep them unpickable; any
  // other combination is allowed here and validated as a whole, so the user
  // can jump months back in either order without fighting the pickers.
  const yesterday = addDays(new Date(), -1);

  return (
    <div>
      <div className="search-input">
        <SearchInput
          className="search-field"
          placeholder="Search by TM ID or Name"
          value={searchParams}
          onChange={handleSearchParam}
        />

        <div style={{ marginTop: -8 }}>
          <MGDatePicker
            containerClassName="flex-row"
            label="Start Date"
            dateFormat="MM/dd/yyyy"
            onChange={(date: Date | null) => date && handleStartDate(date)}
            selected={startDate}
            maxDate={yesterday}
          />
        </div>

        <div style={{ marginTop: -8 }}>
          <MGDatePicker
            containerClassName="flex-row"
            label="End Date"
            dateFormat="MM/dd/yyyy"
            onChange={(date: Date | null) => date && handleEndDate(date)}
            selected={endDate}
            maxDate={yesterday}
          />
        </div>

        <MGButton
          className="apply-button"
          onClick={onApplyDates}
          disabled={applyDisabled}
        >
          Apply
        </MGButton>

        <div style={{ minWidth: 170, marginTop: -8, marginBottom: 26 }}>
          <SelectDropdown
            label="Review status"
            placeholder="All"
            options={REVIEW_STATUS_OPTIONS}
            value={
              REVIEW_STATUS_OPTIONS.find(
                (option) => option.value === reviewStatusFilter
              ) ?? null
            }
            onChange={(option: any) =>
              handleReviewStatusFilter(option?.value || "")
            }
            isClearable
          />
        </div>

        <MGButton
          className="export-button"
          disabled={isExporting}
          onClick={(event: any) => setAnchorEl(event.currentTarget)}
        >
          <FiDownload style={{ marginRight: 4 }} className="assign-icon" />
          <span>{isExporting ? "Exporting…" : "Export"}</span>
        </MGButton>

        <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => handleExport("csv")}>Download as CSV</MenuItem>
          <MenuItem onClick={() => handleExport("xlsx")}>Download as Excel</MenuItem>
        </Menu>
      </div>

      {dateError && (
        <div
          role="alert"
          style={{
            color: "#d32f2f",
            fontSize: 13,
            padding: "0 16px 8px",
          }}
        >
          {dateError}
        </div>
      )}
    </div>
  );
};
